import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

class Toast extends Component {
  static propTypes = {
    toasts: PropTypes.object.isRequired,
  };
  render() {
    const toastClasses = {
      'toast-wrapper': true,
      'toast-wrapper--active': this.props.toasts.size,
    };

    return (
      <div className={classNames(toastClasses)}>
        {this.props.toasts.map((toast, i) => (
          <div
            key={i}
            className="toast"
            style={{
              background: toast.status === 'error' ? '#D64541' : '#2AB759',
            }}
          >
            {toast.message}
          </div>
        ))}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  toasts: state.toasts,
});

export default connect(mapStateToProps)(Toast);



// WEBPACK FOOTER //
// ./src/layout/Toast.js